<div>
    <!------------------------------------------ Back ------------------------------------>
   <div class="">
    <div class="absolute w-[40px] h-[37px] bg-white shadow-lg rounded-full flex justify-center items-center m-2 z-[49]" 
                style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) ;"
                (click)="goback()"
        >
            <img src="icons/Payment/back-payment.png" alt="back" class="w-[30px] h-[30px]" />
      </div>
    </div> 
    <div class="flex flex-col justify-center items-center shadow-md bg-[#FFE9A2]">
        <div class="flex justify-center items-center py-5">
            <p  class=" text-[#5E5D5D] font-bold" 
                [ngClass]="{
                    'text-[24px]': currentLang === 'TH',
                    'text-[22px]': currentLang === 'EN'
                }"
            >
                {{
                    currentLang === "TH"
                    ? "เลือกหมวดหมู่ของคำร้อง"
                    : "Please select the category of your request."
                }}
            </p>
        </div>
    </div>
    <!------------------------------------------- Category ------------------------------------->
    <div class="flex flex-col justify-start items-center mt-2 relative h-[calc(100vh-150px)] bg-gray-200 overflow-y-auto">
        <!---------------------------- Category 1 ------------------------------>
        <div class="w-full h-auto bg-white shadow-md"
             (click)="goToMemberCard()"
        >
            <div class="flex justify-between items-center ">
                <div class="w-[150px] h-[100px] p-2">
                    <img src="images/element-21.png" alt="bill" class="w-full h-full"/>
                </div>
                <div class="flex-1 px-1">
                    <p class="font-semibold text-black"
                       [ngClass]="{
                           'text-[16px]': currentLang === 'TH',
                           'text-[14px]': currentLang === 'EN'
                       }"
                    >
                        {{
                            currentLang === "TH"
                            ? "แก้ไขข้อมูลบัตรสมาชิก"
                            : "Edit Membership Card Information"
                        }}
                    </p>
                </div>
                <div class="w-[80px] h-[80px] p-4 mx-2">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADBklEQVR4nO3dS24TQRAGYIvXISK4Eg8Fhy0KXb5GlkDEKUIAEcKOPVtc5ewQCeFxAXctULJmUFsCCSNCxEzcVdX/L/37VH8az2TGnh6NEARBEARBEARBHKR7P76m/OBeZnquQkfKdKpCXdPlxRocLdZkmjbKGq0EIzOtZ6Ev1RdAbDdz+pyn6c6FQXR748uZ05Pag6qzZqHtrtu6NDgIMOj/UTg9HhiD1msPpc47n01uD4JRTk7l87D2QOq8WejrICf6cjVVexiN0tlk3BskS3pRfRCJ0Sy02/8IkXRcexCN06P+IJxODAzShSinkwGOEAODSJwCRGwVIGKrABFbBYjYKkDEVt2CZE5v5geba6Uqab/2QjYPMj/YXPvt1r/Qbu3FBMifz2Oe1V7QZkFU0n5BiIbiGITKzbiX3dutK8soKmmn9sI2CaIBUdyD6BkoWehp7b+tSRANhBIGRIOghALRACjhQLSU055XlJgg4hclLoj4RIkNIv5Q4oOIL5Q2QMQPSjsg4gOlLRBZ/HDmlWWU9kDENkqbIHImStUnj+2CiE2UtkHEHgpAxBYKQMQWCkBkCWU2uVoTBSBiCwUgcs6PrhV9vQggYgcDIGILAyDyDwxc9raNoc2D8F9vx+PWCTCoYRC2idEmCNvFaA+EbWO0BcL2MdoBYftfbmgHhP1ghAfJDr8JHxYkO8QIC5KdYoQEyY4xwoFk5xihQHIAjDAgOQhGCJAcCMM9SA6G4Rwk4eUzlkDmeD2TXZDO4F3bJl/xl9+l68r3b6jQ69oL2TyIBi1AxFYBIrYKELFVgIitAkSigWBDl264pm9DHCEf6w9CMcrpsDdIhNsVaqZpp/8RMk0b9QehEM2S7vYGKT+QVKZPtYdR5y0bOg+2g3TZ9bj2QOq4men7nOnmIBi/UIS2aw+mTps5PRwNnbIFddn1uPZw6uzIyEyPLmT77p8pux7jnELnaDqeS7o1WkUWJ/rZZLx4aMTpEP880mIXT2X6UJ73l6up5bdFIAiCIAiCIAiCjIzmB65DllFeTwStAAAAAElFTkSuQmCC" alt="right-squared--v1">
            </div>
        </div>
    </div>
</div>